__turbopack_context__.v({
  "audio": "InscriptionContent-module__99pIyW__audio",
  "bitmapArt": "InscriptionContent-module__99pIyW__bitmapArt",
  "chaos": "InscriptionContent-module__99pIyW__chaos",
  "image": "InscriptionContent-module__99pIyW__image",
  "natcat": "InscriptionContent-module__99pIyW__natcat",
  "punks": "InscriptionContent-module__99pIyW__punks",
  "smoothScale": "InscriptionContent-module__99pIyW__smoothScale",
});
